    $(document).ready(function(){
      
      // quantity button for 5 ml sample page 
      
    
$(document).on("click",".custom_add_to_cart",function() {
  var variant_id = $(this).attr("value");
  var qty = $(this).closest("li.product_box").find(".js-qty__num").val();
  data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
    });
   });

// Inner page Js 
      
  $(".toggle").click(function(){
   $(this).toggleClass("active");
     $(this).parent('.sidebar_block').find('.toggle_list').toggle();
  });

// video autoplay of difuser product 
      setTimeout(function() {
       $('.template-product .product .deferred-media__poster-button').trigger('click');  
    },1000);
            
  // button click add to multiple add to cart for 5ml fragrance

       $(document).on("click",".js-qty__adjust--plus",function() {
          var $n = $(this).closest(".js-qty__wrapper").find(".js-qty__num");
          $n.val(Number($n.val())+1);
           
            var grandTotal = 0;
            $('.cstm_itg_checkbox_btn.addproduct').each(function() {
                var pro_price = $(this).closest('.product_box').find('.price').attr('data-price');
                var newthisQty = $(this).closest(".product_box").find('.js-qty__num').val();
                var total =  parseFloat(pro_price) * parseInt(newthisQty); 
                var totalprice = total.toFixed(2); 
                grandTotal += parseFloat(totalprice);
            });
            if(grandTotal == 0){
              $(document).find('.cstm_itg_total').text('$'+ grandTotal);
            }else{
              var final_price = grandTotal.toFixed(2); 
              $(document).find('.cstm_itg_total').text('$'+ final_price);
            }
      });
      
      $(document).on("click",".js-qty__adjust--minus",function() {
            var $n = $(this).closest(".js-qty__wrapper").find(".js-qty__num");
            var amount = Number($n.val());
            if(amount == 1){
              $n.val(1);
            }else{
              $n.val(amount-1);
            }
            var grandTotal = 0;
            $('.cstm_itg_checkbox_btn.addproduct').each(function() {
                var pro_price = $(this).closest('.product_box').find('.price').attr('data-price');
                var newthisQty = $(this).closest(".product_box").find('.js-qty__num').val();
                var total =  parseFloat(pro_price) * parseInt(newthisQty); 
                var totalprice = total.toFixed(2); 
                grandTotal += parseFloat(totalprice);
            });
            if(grandTotal == 0){
              $(document).find('.cstm_itg_total').text('$'+ grandTotal);
            }else{
              var final_price = grandTotal.toFixed(2); 
              $(document).find('.cstm_itg_total').text('$'+ final_price);
            }
      });
      
  $(document).on("click",".cstm_itg_checkbox_btn",function() {
    
      if($(this).hasClass('addproduct')) {
        $(this).removeClass('addproduct');
        $(this).text('Add');
      }else{
         $(this).text('Added');
         $(this).addClass('addproduct');
      }

    var grandTotal = 0;
    $('.cstm_itg_checkbox_btn.addproduct').each(function() {
        var pro_price = $(this).closest('.product_box').find('.price').attr('data-price');
        var newthisQty = $(this).closest(".product_box").find('.js-qty__num').val();
        var total =  parseFloat(pro_price) * parseInt(newthisQty); 
        var totalprice = total.toFixed(2); 
        grandTotal += parseFloat(totalprice);
    });
    if(grandTotal == 0){
      $(document).find('.cstm_itg_total').text('$'+ grandTotal);
    }else{
       var final_price = grandTotal.toFixed(2); 
      $(document).find('.cstm_itg_total').text('$'+ final_price);
    }
  
  }); 

  $(document).on("click",".itg_custom_reset",function() {
        $(document).find('.cstm_itg_total').text('$0');         
        $(document).find('.cstm_itg_checkbox_btn').text('Add');
        $(document).find('.cstm_itg_checkbox_btn').removeClass('addproduct');
        $(document).find('.js-qty__num').val('1');
  }); 
   $(document).on("click",".cstm_itg_checkbox_btn.addproduct",function() {
      $(this).closest("li.product_box").find('.js-qty__num').val('1');
   });  

$(document).on("click",".cstm_itg_custom_add_to_cart",function() {
      var length = $(document).find(".addproduct").length;
      if(length != 0){
       $(document).find('.itg_loader').addClass('loading');
      
         var available_ids = [];
          $(".cstm_itg_checkbox_btn").each(function(){          
            if($(this).hasClass('addproduct')) {   
              var newthisQty = $(this).closest("li.product_box").find('.js-qty__num').val();
               var thisId  = $(this).val();
                var thisQty = newthisQty;
                var toPushItem = thisId+'-'+thisQty;
          	    available_ids.push(toPushItem);
             }
           });

           for (var i = 0; i < available_ids.length; i++) {
              (function(i){
                  setTimeout(function(){
                        var formContents = available_ids[i].split('-');
                        var params = {
                            type: 'POST',
                            url: '/cart/add.js',
                            data: 'quantity='+formContents[1]+'&id='+formContents[0],
                            dataType: 'json',
                            success: function(line_item) { 
                              var iteration_length = i+1;
                              if( iteration_length == available_ids.length ){
                                $(document).find('.itg_loader').removeClass('loading');
                                document.location.href = '/cart'; 
                              }
                            },error: function() {
                                console.log("fail");
                            }
                        };
                        $.ajax(params); 
                  }, 1000 * i);
              }(i));
          }
      }else{
      alert('Please Add Atleast One Product');
      return false;
    }
 });
// End-button click add to multiple add to cart for 5ml fragrance

    // button click add to multiple add to cart 
    
  $(document).on("click", ".itg_checkbox_btn", function () {
    
      if($(this).hasClass('addproduct')) {
        $(this).removeClass('addproduct');
        $(this).text('Add');
      }else{
         $(this).text('Added');
         $(this).addClass('addproduct');
      } 

         var count = 0;  
         var grandTotal = 0;  
       $(".itg_checkbox_btn").each(function(){
         if($(this).hasClass('addproduct')) {  
             count++;
            var pro_price = parseFloat($(this).closest('.product_box').find('.price').attr('data-price'));           
            grandTotal += pro_price; 
            $('.itg_total_qnty').text(count+ ' Count');
          }else{
            $('.itg_total_qnty').text(count+' Count');
           var pro_price = 0;
           grandTotal += pro_price;            
         }
       }); 
    
     var grandTotal = grandTotal.toFixed(2); 
     $(document).find('.itg_total').text('');
       if(grandTotal != 0){
         $(document).find('.itg_total').text('$'+grandTotal);
       }else{
         $(document).find('.itg_total').text('$ 0.00');
       }
    
       var length = $(document).find(".addproduct").length;
       if(length == 10){
          $('.itg_checkbox_btn').prop('disabled', true);
          $(document).find('.itg_custom_add_to_cart').attr('disabled', false);
       }else{
         $('.itg_checkbox_btn').prop('disabled', false);
         $(document).find('.itg_custom_add_to_cart').attr('disabled', true);
       }
  });

  $(document).on("click",".custom_reset",function() {
        $(document).find('.itg_total_qnty').text('0 Count');
        $(document).find('.itg_total').text('$ 0.00');
        $(document).find('.itg_custom_add_to_cart').attr('disabled', true);       
        $(document).find('.itg_checkbox_btn').prop('disabled', false);
        $(document).find('.itg_checkbox_btn').text('Add');
        $(document).find('.itg_checkbox_btn').removeClass('addproduct');
    });     
  
  $(document).on("click", "button.itg_custom_add_to_cart", function () {
    var length = $(document).find(".addproduct").length;
    if(length == 10){
      var variant_idd = $(this).val();
      var arrdata = {};
      $("button.itg_checkbox_btn.addproduct").each(function (index) {
          var index = index+1;
          var pro_handal = $(this).attr("data-attr");
          arrdata['Box_'+index] = pro_handal;
      });
      var data1 = {
        id: variant_idd,
        quantity: 1,
        "properties":arrdata 
      }
      jQuery.ajax({
        type:'POST',
        url:'/cart/add.js',
        data:data1,
        dataType:'json',
        success: function () {
          window.location.href = "/cart";
        }
      });
    }else{
      alert('Please select 10 items');
      return false;
    }
      
   });
    
}); 

      
 